import React from "react";

const translations = {
  en: { noResults: "No results found." },
  fr: { noResults: "Aucun résultat trouvé." },
};

export default function NoResults() {
  const lang = document.documentElement.lang || "en";
  const t = translations[lang] || translations.en;
  return (
    <div className="search-no-results">
      <p>{t.noResults}</p>
    </div>
  );
}
